// @flow
import dayjs from "dayjs";

const todayTomorrowDateFormat = (
  date: string,
  year: boolean = false,
  time: boolean = true
) => {
  if (!date) {
    return "";
  }

  const dayjsDate = dayjs(date);
  const now = dayjs();

  if (dayjsDate.isSame(now, "day")) {
    return dayjsDate.format(time ? "[Today at] HH:mm" : "[Today]");
  }

  if (dayjsDate.isSame(now.add(1, "days"), "day")) {
    return dayjsDate.format(time ? "[Tomorrow at] HH:mm" : "[Tomorrow]");
  }

  return year
    ? dayjsDate.format(`D MMMM YYYY${time ? " [at] HH:mm" : ""}`)
    : dayjsDate.format(`Do MMMM${time ? " [at] HH:mm" : ""}`);
};

export default todayTomorrowDateFormat;
